import React, { useState, useEffect, useRef, useCallback } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  ArcElement
} from "chart.js";
import { useUser } from "./userContext";
import config from "./config";
import axios from "axios";
import { sharedData } from "../sharedData/sharedData";
import { primeDiligenceFromRow } from "../utils/navigationHelper";
import "./Dashboard.css";

import { useRequest } from "./RequestContext";
import { useNavigate } from "react-router-dom";
import { useModal } from "../hooks/useModal";
import { Modal } from "./ui/Modal";
import { userSession } from "../observers/userObserver";
import { capitalizeName } from "../utils/utils";
import LoadingGate from "./loadingGate";
import ConfirmationModal from "./ui/ConfirmationModal";
import {  useUserSession } from "../context/userSession";
import ConfirmationModalv2 from "./ui/ConfirmationModal_v2";
import { resetFormCache } from "../utils/resetFormCache";

ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip);

const Dashboard = () => {
  const navigate = useNavigate();
  // const { getUserEmail, getUserName, getToken } = useUserSession();
  const { updateRequestId } = useRequest();
  const [selectedDropdownId, setSelectedDropdownId] = useState(null);
  const [selectedToDeleteRequestId, setSelectedToDeleteRequestId] = useState(null);
  const [selectedDropdownMLNOId, setSelectedDropdownMLNOId] = useState(null);
  const [userRequests, setUserRequests] = useState([]);
  const [mlnoRequest, setMlnoRequests] = useState([]);
  const [logoUrl, setLogoUrl] = useState("");
  const [address, setAddress] = useState("");
  const [userName, setUserName] = useState(userSession.getUserName());
  const {modalOpen, setModalOpen, modalMessage, setModalMessage, modalHeading} = useModal(false);
  const { modalOpen:isDeleteConfirmationModalOpen, setModalOpen:setIsDeleteConfirmationModalOpen } = useModal(false);

  const [transactionData, setTransactionData] = useState(null); // For Bar Chart
  const [processingData, setProcessingData] = useState(null);   // For Line Chart


    
    const fetchMonthlyData = async () => {
      try {
        const token = userSession.getToken();
        const userEmail = userSession.getUserEmail();
    
        const res = await axios.post(
          `${config["backend-url"]}/get_monthly_request_count`,
          { userEmail },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
    
        const statusCounts = res.data.status_counts || [];
        const labels = statusCounts.map((item) => item.status);
        const values = statusCounts.map((item) => item.count);
    // 👇 Map status to color
const getColorForStatus = (status) => {
  switch (status) {
    case "Completed":
    case "Complete":
      return "#07b1b0"; // cyan
    case "In Progress":
    case "User Pending":
    case "Pending":
    case "Pending COD":
      return "#f49c28"; // orange
    case "Pending MLNO":
      return "#dc3545"; // red
    case "Deleted":
    case "deleted":
      return "#687784"; // grey
    default:
      return "#07b1b0"; // fallback cyan
  }
};

const backgroundColors = labels.map((status) => getColorForStatus(status));
       setProcessingData({
  labels,
  datasets: [
    {
      label: "Requests by Status",
      data: values,
      backgroundColor: backgroundColors,
      borderRadius: 10, // 👈 rounded bars
      barThickness: 15,
    },
  ],
});
      } catch (error) {
        console.error("Error fetching monthly request data:", error);
      }
    };
    const fetchStatusData = async () => {
    try {
      const token = userSession.getToken();
      const userEmail = userSession.getUserEmail();

      const res = await axios.post(
        `${config["backend-url"]}/get_diligence_status_wise_request_count`,
        { userEmail },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const statusCounts = res.data.status_wise_counts;

      // Filter only "In Progress" and "Completed"
      const filteredStatuses = ["Enhanced", "Simplified","Standard","Unknown"];
      const labels = filteredStatuses;
      const values = filteredStatuses.map((status) => statusCounts[status] || 0);
console.log("data value:", values)
      setTransactionData({
        labels,
        datasets: [
          {
            data: values,
            backgroundColor: ["#000000", "#d3d3d3", "#07b1b0", "#f0f0f0"],
            borderWidth: 0, // Optional: Remove borders from pie slices
          },
        ],
      });
    } catch (error) {
      console.error("Error fetching request status data:", error);
    }
  };

  useEffect(() => {
    fetchStatusData();
  }, []);
    
    
   const pieChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  hoverOffset: 0,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: "#333",
      titleColor: "#fff",
      bodyColor: "#fff",
      cornerRadius: 6,
      padding: 8,
      displayColors: false,
      callbacks: {
        label: (context) => {
          const label = context.label || '';
          const value = context.formattedValue || '';
          return `${label}: ${value}`;
        },
        title: () => null
      }
    }
  },
  elements: {
    arc: {
      hoverBackgroundColor: (context) => {
        const color = context.element?.options?.backgroundColor || '#000';
        return color + 'B3'; // 70% opacity
      }
    }
  }
};

    const hoverCirclePlugin = {
  id: 'hoverCirclePlugin',
  afterDraw: (chart) => {
    const tooltip = chart.tooltip;
    if (tooltip?._active?.length) {
      const ctx = chart.ctx;
      const { x, y } = tooltip._active[0].element;

      ctx.save();
      ctx.beginPath();
      ctx.arc(x, y, 18, 0, 2 * Math.PI); // Adjust radius here (smaller than chart)
      ctx.fillStyle = '#fff'; // White background
      ctx.fill();

      // Draw text inside the circle
      ctx.fillStyle = '#000'; // Text color
      ctx.font = 'bold 12px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      const value = tooltip.dataPoints[0].formattedValue;
      ctx.fillText(value, x, y);
      ctx.restore();
    }
  },
};

    
    const fetchMLNODetail = async () => {
    try {
      const token = userSession.getToken();
      const response = await fetch(`${config["backend-url"]}/get_10_requests_MLNO`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      const data = await response.json();
  
      if (response.ok) {
        const requests = data.data.map((request) => ({
          id: request.request_id,
          transactionId: request.transaction_id,
          transaction: request.transaction_reference || "N/A",
          Deligence_status: request.diligenceStatus || "N/A",
          client: request.client || "N/A",
          property: request.property_name || "N/A",
          propertyId: request.PropertyId,
          status: request.status || "N/A",
          entityId: request.EntityId,
          created_at: request.created_at || "N/A",
          modified_at: request.modified_at || "N/A",
          requester: request.requester || "N/A",
          pending_action: request.pending_action || "No",
          customer_name: request.customer_name || "N/A",
          Approved_At:request.Approved_At || "N/A",
          clientReferenceNumber: request.client_reference_number || "N/A",
        }));
  
        setMlnoRequests(requests);
      } else {
        console.error("Failed to fetch user requests:", data);
      }
    } catch (error) {
      console.error("Error fetching user requests:", error);
    }
  };

  const deleteRequest = async (requestId) => {
    try {
      const token = userSession.getToken();
      const response = await fetch(`${config["backend-url"]}/delete_request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ request_id:requestId }),
      })

      if (response.ok) {
        fetchUserRequests();
      }

    } catch (error) {
      console.error("Error fetching user requests:", error);
    }
  };
  

    const fetchUserRequests = async () => {
      try {
        const token = userSession.getToken();
        const response = await fetch(`${config["backend-url"]}/get_10user_request`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();

        if (response.ok) {
          setLogoUrl(data.customer_logo);
          const addressFields = [
            data.customer_address.address1,
            data.customer_address.address2,
            data.customer_address.city,
            data.customer_address.state,
            data.customer_address.country,
            data.customer_address.postcode,
          ];
          setAddress(addressFields.filter(Boolean).join(", "));

          const requests = data.requests.map((request) => ({
            id: request.request_id,
            transactionId: request.transaction_id || request.TransactionId,
            transactionId: request.transaction_id || request.TransactionId,
            transaction: request.transaction_reference || "N/A",
            Deligence_status: request.Deligence_status,
            client: request.company_name || "N/A",
            property: request.property_name || "N/A",
            propertyId: request.PropertyId,
            created_at: request.created_at || "N/A",
            modified_at: request.modified_at || "N/A",
            status: request.Request_Status,
            entityId: request.EntityId,
            MLNO_Approved_At: request.MLNO_Approved_At || "N/A",
            clientReferenceNumber: request.client_reference_number || "N/A",
          }));
          setUserRequests(requests);
        } else {
          console.error("Failed to fetch user requests:", data);
        }
      } catch (error) {
        console.error("Error fetching user requests:", error);
      }
    };


  useEffect(()=>{
    userSession.subscribe((user, token) => {
      setUserName(capitalizeName(user.userName));
      if (token != null) {
        user.userMLNOFlag && setMLNOFlag(user.userMLNOFlag);
        if (user.userMLNOFlag) {
          fetchMLNODetail();
        }
        fetchStatusData();
        fetchMonthlyData();
        fetchUserRequests();
      }
    })
  }, []);



  // Landing on the dashboard means no request is open, so drop every cached form value.
  // This used to remove five named keys and left riskFormData, riskFormDataContinued,
  // managers, managersStatus, EDDFormData and loadedDocs behind — which is why Risk
  // Assessment, Risk Assessment Continue, Management Structure and EDD were the pages that
  // opened pre-filled and locked with the previous request's status.
  useEffect(() => {
    sharedData.clear();
    resetFormCache();
  }, []);

  const [MLNOFlag, setMLNOFlag] = useState("");

  const dropdownRef = useRef(null);
  const mlnoDropdownRef = useRef(null);

  const handleToggleDropdown = (id) => {
    setSelectedDropdownId(selectedDropdownId === id ? null : id);
  };

  const handleMLNOToggleDropdown = (id) => {
    setSelectedDropdownMLNOId(selectedDropdownMLNOId === id ? null : id);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      // Check if click is outside user requests dropdown
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSelectedDropdownId(null);
      }
      // Check if click is outside MLNO requests dropdown
      if (mlnoDropdownRef.current && !mlnoDropdownRef.current.contains(event.target)) {
        setSelectedDropdownMLNOId(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const getStatusClass = (status) => {
    switch (status) {
      case "Completed":
      case "Complete":
      case "Validated":
      case "Active":
        return "status-closed";
      case "In Progress":
      case "User Pending":
      case "Pending":
      case "Pending COD":
        return "status-in-progress";
      case "Pending MLNO":
        return "status-pending-mlno";
      case "Deleted":
      case "deleted":
        return "status-deleted";
      case "InActive":
        return "status-inactive";
      case "Not Started":
        return "status-not-started";
      default:
        return "";
    }
  };

  const handleAddRequest = async () => {
    setModalMessage("Creating a new request...");
    setModalOpen(true);
    try {
      const username = localStorage.getItem("userName");
      const useremail = localStorage.getItem("userEmail");
      const token = userSession.getToken();
      const refreshToken = userSession.getRefreshToken();

      const response = await fetch(`${config["backend-url"]}/create_request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({}),
      });

      const data = await response.json();

      if (response.ok) {
        const requestId = data.request_id;
        updateRequestId(requestId);
        sharedData.clear();

        // Full reset so the previous request's "Validated" status cannot bleed into this
        // new request and lock its screens.
        resetFormCache();

        sharedData.set("requestId", requestId);

        setModalMessage("Request created successfully!");
        setModalOpen(false);
        navigate(`/transaction-detail`);
      } else {
        setModalMessage(<>
          Failed to create request
          Error: 
          <pre>{JSON.stringify(data)}</pre>
        </>);
        setModalOpen(false);
        console.error("Failed to create request", data);
      }
    } catch (error) {
      setModalMessage(<>
        Failed to create request
        Error: 
        <pre>{JSON.stringify(error)}</pre>
      </>);
      setModalOpen(false);
      console.error("Error during API call:", error);
    }
  };

  const handleDeleteRequest = (requestId) => {
    setSelectedToDeleteRequestId(requestId);
    setIsDeleteConfirmationModalOpen(true);
  }

  const handleConfirmDelete = () => {
    // call api, change the status to deleted
    deleteRequest(selectedToDeleteRequestId);
    setIsDeleteConfirmationModalOpen(false); // close modal
    setSelectedToDeleteRequestId(null);              // cleanup
  }

  const userType = userSession.getUserType();

  const CompanyRequests = [
    {
      id: "REQ-001",
      client: "Acme Corp",
      property: "123 Main St",
      requester: "John Doe",
      diligenceStatus: "In Progress",
      status: "in-progress",
      pendingAction: "Awaiting Documents",
      unreadMessages: 3,
      transaction: "TXN001",
      entityId: "ENT001",
      propertyId: "PROP001",
    },
    {
      id: "REQ-002",
      client: "Beta LLC",
      property: "456 Elm Ave",
      requester: "Jane Smith",
      diligenceStatus: "Completed",
      status: "closed",
      pendingAction: "None",
      unreadMessages: 0,
      transaction: "TXN002",
      entityId: "ENT002",
      propertyId: "PROP002",
    },
  ];
  
  return (
      <div className="dashboard">
      {/* <h4 className="welcomeText">Welcome to your dashboard, {userName || "Guest"}</h4> */}
      {/* <div className="dashboard-header">
        <button className="add-request" onClick={handleAddRequest}>Add New Request</button>
        <div className="user-info">
          <span className="address">{address}</span>
          <div className="user-image">
            <img src={logoUrl} className="userimg" alt="User" />
          </div>
        </div>
      </div> */}

      <div className="quick-view">
        {/* <h3>Quick View</h3> */}
        <div className="graphs" style={{ display: 'flex', height: '300px', gap: '1rem',paddingBottom:"40px" }}>
<div className="graph" style={{ flex: '1', height: '100%', paddingBottom: '40px' }}>
  <h4>Diligence Status - 60 day</h4>
  {!transactionData ? (
    <p>Loading status chart...</p>
  ) : transactionData.datasets[0].data.every((val) => val === 0) ? (   // 👈 check for all zeros
     <div className="pie-chart-container" style={{ textAlign: "center" }}>
    <div style={{ width: "100%", height: "100%", aspectRatio: 1, margin: "0 auto" }}>
      <Pie
        data={{
          labels: ["Placeholder A", "Placeholder B"],
          datasets: [
            {
              data: [70, 30], // two equal slices
              backgroundColor: ["#e0e0e0", "#f0f0f0"], // two light greys
              borderWidth: 1,
              borderColor: "#fff",
            },
          ],
        }}
        options={{
          plugins: {
            legend: { display: false }, // hide legend for empty state
            tooltip: { enabled: false }, // no hover tooltips
          },
        }}
      />
    </div>
    <p
      style={{
        marginTop: "12px",
        color: "#666",
        fontStyle: "italic",
        fontSize: "14px",
      }}
    >
      No request has been created yet
    </p>
  </div>
  ) : (
    <div className="pie-chart-container">
      <div style={{ width: '100%', height: '100%', aspectRatio: 1 }}>
        <Pie data={transactionData} options={pieChartOptions} />
      </div>
      <div className="custom-legend">
        {transactionData.labels.map((label, idx) => (
          <div className="legend-item" key={idx}>
            <span
              className="legend-color"
              style={{
                backgroundColor: transactionData.datasets[0].backgroundColor[idx],
              }}
            />
            <span className="legend-label">{label}</span>
          </div>
        ))}
      </div>
    </div>
  )}
</div>





  <div className="graph" style={{ flex: '1', height: '100%', paddingBottom: "40px" }}>
  <h4>Detailed Request Status - 60 day</h4>
  {!processingData ? (
    <p>Loading processing chart...</p>
  ) : processingData.labels?.length === 0 ? (
    <div style={{ width: "100%", height: "87%" }}>
      <Bar
        data={{
          labels: ["Example A", "Example B", "Example C"],
          datasets: [
            {
              label: "No Data",
              data: [3, 2, 4], // dummy filler values
              backgroundColor: "#e0e0e0",
              borderWidth: 1,
              barThickness: 15,
            },
          ],
        }}
        options={{
          indexAxis: "y",
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: { enabled: false }, // disable tooltips for dummy
          },
          scales: {
            x: {
              beginAtZero: true,
              ticks: { precision: 0 },
              title: { display: true, text: "Count" },
            },
            y: {
              title: { display: true, text: "Status" },
            },
          },
        }}
      />
      <div
        style={{
          textAlign: "center",
          marginTop: "10px",
          color: "#888",
          fontStyle: "italic",
        }}
      >
        No request has been created yet
      </div>
    </div>
  ) : (
    <Bar
      data={{
        ...processingData,
        datasets: processingData.datasets.map((dataset) => ({
          ...dataset,
          barThickness: 15,
        })),
      }}
      options={{
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: true },
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: { precision: 0 },
            title: { display: true, text: "Count" },
          },
          y: {
            title: { display: true, text: "Status" },
          },
        },
      }}
      style={{ width: "100%", height: "87%" }}
    />
  )}
</div>


</div>


      </div>

      <div className="recent-requests">
        <div className="table-header">
          <h3>Recent User Requests</h3>
          <div className="view-all" onClick={() => navigate("/all-requests")}>
            View All Requests
          </div>
        </div>

        <table className="request-table">
          <thead>
            <tr>
              <th>Request ID</th>
              <th>Client Reference Number</th>
              <th>Transaction Reference</th>
              <th>Client/ Counterparty</th>
              <th>Property</th>
              <th>Diligence Status</th>

              <th>Opened Date</th>
              {/* <th>Last Modified On</th>
              <th>Date of Report</th> */}
              <th>Status</th>

              <th></th>
            </tr>
          </thead>
          <tbody>
             {userRequests.length === 0 ? (
    <tr>
      <td colSpan="9" style={{ textAlign: "center", padding: "20px" }}>
        No request has been created yet
      </td>
    </tr>
  ) : (
    userRequests.map((row) => (
            
              <tr key={row.id}>
                <td>{row.id}</td>
                <td>{row.clientReferenceNumber}</td>
                <td>{row.transaction}</td>
                <td data-entityid={row.entityId}>{row.client}</td>
                <td data-propertyid={row.propertyId}>{row.property}</td>

                <td>{row.Deligence_status}</td>
                
                <td>{row.created_at}</td>
                
                {/* <td>{row.modified_at}</td>
                <td>{row.MLNO_Approved_At}</td> */}


                <td>
                  <span className={`status-tile ${getStatusClass(row.status)}`}>{row.status}</span>
                </td>
                <td>
                  <div className="dropdown-container" ref={selectedDropdownId === row.id ? dropdownRef : null}>
                    <button className="dropdown-btn" onClick={() => handleToggleDropdown(row.id)}>
                      <BsThreeDotsVertical size={20} />
                    </button>
                    {selectedDropdownId === row.id && (
                      <div className="custom-dropdown">
                        <div
                          className="dropdownItem"
                          onClick={() => {
                            sharedData.set("requestId", row.id);
                            sharedData.set("transactionId", row.transactionId);
                            sharedData.set("entityId", row.entityId);
                            sharedData.set("propertyId", row.propertyId);
                            sharedData.set("status", row.status);
                            primeDiligenceFromRow(row);
                            navigate("/transaction-detail?view=true&readonly=true");
                          }}
                        >
                          View
                        </div>
                        {/* <span>{JSON.stringify(row)}</span> */}

                        {row.status !== "Completed" && row.status !== "Complete" && (

                          <div
                            className="dropdownItem"
                            onClick={() => {
                              sharedData.set("requestId", row.id);
                              sharedData.set("transactionId", row.transactionId);
                              sharedData.set("entityId", row.entityId);
                              sharedData.set("propertyId", row.propertyId);
                              sharedData.set("status", row.status);
                              primeDiligenceFromRow(row);
                              navigate("/transaction-detail?edit=true");
                            }}
                          >
                            Edit
                          </div>
                        )}
                        {(row.status === "Complete" || row.status === "Completed") && (
  <div
    className="dropdownItem"
    onClick={() => {
      sharedData.set("requestId", row.id);
      sharedData.set("transactionId", row.transactionId);
      sharedData.set("entityId", row.entityId);
      sharedData.set("propertyId", row.propertyId);
      sharedData.set("status", row.status);
      primeDiligenceFromRow(row);
        navigate("/FinalReview");
    }}
  >
    Report
  </div>
)}
{true && <div className="dropdownItem" onClick={() => {
  handleDeleteRequest(row.id)
}}>
  Delete
  </div>}
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))
  )}
          </tbody>
        </table>
      </div>

   

{MLNOFlag && (
  <div className="recent-requests">
    <div className="table-header">
      <h3>Recent Company Requests</h3>
    </div>

    <table className="request-table">
      <thead>
        <tr>
          <th>Request ID</th>
          <th>Client/ Counterparty</th>
          <th>Client Reference Number</th>
          <th>Property</th>
          <th>Fee Earner</th>
          <th>Diligence Status</th>
          <th>Status</th>
          <th>Opened Date</th>
          <th>Last Modified on</th>
          <th>Date of Report</th>

          <th>Unread Messages</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {mlnoRequest.length === 0 ? (
    <tr>
      <td colSpan="12" style={{ textAlign: "center", padding: "20px" }}>
        No request has been created yet
      </td>
    </tr>
  ) : (
    mlnoRequest.map((row) => (
          <tr key={row.id}>
            <td>{row.id}</td>
            <td>{row.client}</td>
            <td>{row.clientReferenceNumber}</td>
            <td>{row.property}</td>
            <td>{row.requester || "N/A"}</td>
            <td>{row.Deligence_status || "N/A"}</td>
            <td>
              <span className={`status-tile status-${row.status?.toLowerCase().replace(/\s/g, '-')}`}>
                {row.status}
              </span>
            </td>
            <td>{row.created_at }</td>
            <td>{row.modified_at }</td>
            <td>{row.Approved_At }</td>
            <td>{row.unreadMessages || 0}</td>
            <td>
              <div className="dropdown-container" ref={selectedDropdownMLNOId === row.id ? mlnoDropdownRef : null}>
                <button
                  className="dropdown-btn"
                  onClick={() => handleMLNOToggleDropdown(row.id)}
                >
                  <BsThreeDotsVertical size={20} />
                </button>
                {selectedDropdownMLNOId === row.id && (
                  <div className="custom-dropdown">
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        sharedData.set("requestId", row.id);
                        sharedData.set("transactionId", row.transactionId);
                        sharedData.set("entityId", row.entityId);
                        sharedData.set("propertyId", row.propertyId);
                        sharedData.set("status", row.status);
                        navigate("/transaction-detail?view=true&readonly=true");
                      }}
                    >
                      View
                    </div>
                    {row.status !== "Completed"  && row.status !== "Complete" && row.status !== "Deleted"  &&  (
                      <div
                        className="dropdownItem"
                        onClick={() => {
                          sharedData.set("requestId", row.id);
                          sharedData.set("transactionId", row.transactionId);
                          sharedData.set("entityId", row.entityId);
                          sharedData.set("propertyId", row.propertyId);
                          sharedData.set("status", row.status);
                          navigate("/transaction-detail?edit=true");
                        }}
                      >
                        Edit
                      </div>
                    )}
                  </div>
                )}
              </div>
            </td>
          </tr>
        ))
  )}
      </tbody>
    </table>
  </div>
)}

      <ConfirmationModalv2
        isOpen={isDeleteConfirmationModalOpen}
        heading="Delete Confirmation"
        message={`Are you sure you want to delete this Request (ID: ${selectedToDeleteRequestId})?`}
        onClose={() => setIsDeleteConfirmationModalOpen(false)}
        confirmText="Delete"
        onConfirm={handleConfirmDelete}
        cancelText="Cancel"
      />
      {/* {modalOpen && <Modal 
        modalHeading={""}
        modalMessage={modalMessage}
        onClick={()=>setModalOpen(false)}
      />} */}
       <ConfirmationModal
        isOpen={modalOpen}
        heading= {modalHeading}
        message={modalMessage}
        onClose={() => setModalOpen(false)}
      />
    </div>
  );
};

export default Dashboard;
